// 
export const VESSEL_LIST = 'VESSEL_LIST';
export const VESSEL_PAGINATION = 'VESSEL_PAGINATION';
 